import { render } from "./ReportsDashboard.vue?vue&type=template&id=7e823014&scoped=true"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js"

import "./ReportsDashboard.vue?vue&type=style&index=0&id=7e823014&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e823014"]])

export default __exports__